/*
 * @Author: your name
 * @Date: 2020-11-12 11:32:16
 * @LastEditTime: 2020-11-12 11:41:59
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \orange_big_data\src\utils\util.js
 */
// 提示框显示位置
const tipsPosition = (point, params, dom, rect, size) => {
	// 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
	// 提示框位置
	var x = 0; // x坐标位置
	var y = 0; // y坐标位置

	// 当前鼠标位置
	var pointX = point[0];
	var pointY = point[1];

	// 提示框大小
	var boxWidth = size.contentSize[0];
	var boxHeight = size.contentSize[1];

	// boxWidth > pointX 说明鼠标左边放不下提示框
	if (boxWidth > pointX) {
		x = 5;
	} else {
		// 左边放的下
		x = pointX - boxWidth;
	}

	// boxHeight > pointY 说明鼠标上边放不下提示框
	if (boxHeight > pointY) {
		y = 5;
	} else {
		// 上边放得下
		y = pointY - boxHeight;
	}

	return [ x, y ];
};
// 设置echarts字体自适应
const fontSizeFun = (res) => {
	let docEl = document.documentElement,
		clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	let fontSize = '';
	//设计图参考宽度
	let design = 1024;
	if (clientWidth > 1680)
		// 大屏
		fontSize = clientWidth / 1680 * 100;
	else if (clientWidth > design) fontSize = 100;
	else
		// 小屏
		fontSize = clientWidth / design * 100;
	return res * fontSize;
};
let util = {
  tipsPosition,
  fontSizeFun
}
export default util;



// WEBPACK FOOTER //
// ./src/utils/util.js